import { Settings } from "react-slick";

import { Responsive, StrictConfig } from "./Slider.types";

export const defaultSettings: Settings = {
  arrows: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 0
};

export const getSelectedDimension = (
  responsive: Responsive[],
  windowWidth: number
): StrictConfig | undefined => {
  const responsiveCandidate = responsive.find(
    item => item.breakpoint > windowWidth
  );
  const { config } = responsiveCandidate ?? {};
  if (!config) {
    return;
  }
  const { width } = config;
  if (typeof width !== "number") {
    return { ...config, width: windowWidth };
  }
  return config as StrictConfig;
};

export const getSettings = (overrides: Partial<Settings> = {}): Settings => {
  return { ...defaultSettings, ...overrides };
};
